$('.module--carousel-wrapper').slick({
    slidesToShow: 5,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    arrows: false,
    variableWidth: true
  });

$('.product-slider').slick({
    slidesToShow: 1,
    infinite: true,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  });

  
  // const option1Li = document.getElementById("border-lii");
  // const option2Li = document.getElementById("border-li");
  // const changeButton = document.getElementById("checkout-link");
  
  // option1Li.addEventListener("click", function () {
  //   changeButton.textContent = "ADD TO CART";
  // }); 
  
  // option2Li.addEventListener("click", function () {
  //   changeButton.textContent = "ADD TO CART";
  // });

  jQuery(window).scroll(function () {
      if(jQuery(window).scrollTop() > 20) {
          jQuery("header#landing-header").addClass('sticky');
      } else {
          jQuery("header#landing-header").removeClass('sticky');
      }
  });
  

  $(document).ready(function() {
    /*
    var $weekSelector = $("#week-selector");
    var $checkoutLink = $("#checkout-link");
    var $dropdownItem1 = $("#border-lii");
    var $dropdownItem2 = $("#border-li");
  
    // Attach a change event listener to the week selector
    $weekSelector.on("change", function() {
      // Remove the selected attribute from all options
      $weekSelector.find("option").removeAttr("selected");
      
      // Add the selected attribute to the currently selected option
      $(this).find("option:selected").attr("selected", "selected");
      
      // Get the value of the selected option and set it as the data-link attribute of $dropdownItem1
      var selectedValue = $(this).val();
      $dropdownItem1.attr("data-link", selectedValue);
    });
  
    /*
    // Attach a click event listener to $dropdownItem1
    $dropdownItem1.on("click", function() {
      // Get the data-link attribute value and set it as the href attribute of $checkoutLink
      var selectedValue = $(this).attr("data-link");
      $checkoutLink.attr("href", selectedValue);
    });
  
    // Attach a click event listener to $dropdownItem2
    $dropdownItem2.on("click", function() {
      // Get the data-link attribute value and set it as the href attribute of $checkoutLink
      var selectedValue = $(this).attr("data-link");
      $checkoutLink.attr("href", selectedValue);
    });
    */
    /*
    // Trigger a change event on the week selector to initialize the data-link attribute
    $weekSelector.trigger("change");
    */


    var isToggling = false;

    $(window).scroll(function() {
      if (isToggling) {
          return;
      }
      // console.log('Test');
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      var triggerPoint = 0.2 * windowHeight;

      if (scroll >= triggerPoint && !$(".header__container").hasClass('header__container--hide')) {
          isToggling = true;
          $(".header__container").addClass('header__container--hide');
        $(".header__announcement").addClass('header__container--hide');
          setTimeout(function() {
              isToggling = false;
          }, 200); // Adjust the timeout as needed
      } else if (scroll < triggerPoint && $(".header__container").hasClass('header__container--hide')) {
          isToggling = true;
          $(".header__container").removeClass('header__container--hide');
        $(".header__announcement").removeClass('header__container--hide');
          setTimeout(function() {
              isToggling = false;
          }, 200); // Adjust the timeout as needed
      }
    });

    jQuery('.button.bogo_atc_btn.csapp_btn.grid_atc_btn, .special-bonus-bndl-discount form button').click(function(){
      fbq('track', 'AddToCart');
      // console.log('ATC')
    });
  });


document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.collapsible--item');

  items.forEach(item => {
    const question = item.querySelector('.collapsible--question');
    const answer = item.querySelector('.collapsible--answer');

    if (!question || !answer) return;

    question.addEventListener('click', function () {
      const isOpen = question.classList.contains('is-open');

      // Close ALL OTHER items
      items.forEach(other => {
        if (other !== item) {
          const q = other.querySelector('.collapsible--question');
          const a = other.querySelector('.collapsible--answer');

          q.classList.remove('is-opens');
          a.classList.remove('is-opens');
        }
      });

      // Toggle current
      if (isOpen) {
        question.classList.remove('is-open');
        answer.classList.remove('is-open');
        console.log('Closed');
      } else {
        question.classList.add('is-open');
        answer.classList.add('is-open');
        console.log('Opened');
      }
    });
  });
});
